import { Checkbox } from "@/components/ui/checkbox";
import { Attribute } from "../../models";
import { useClipProducts } from "../../catalogue/use-clip-products";
import { getSelectedLayerConfigs } from "../../catalogue/catalogue-utils";

interface DataTreeProps {
  selected: Attribute[];
}


export const DataTree = (props: DataTreeProps) => {
  const productsQuery = useClipProducts();
  const catalogue = productsQuery.data ?? [];

  const selectedProducts = catalogue.filter((product) =>
    props.selected.some(
      (s) => s.key === product.productKey && s.attributes.length > 0,
    ),
  );

  return (
    <>
      {selectedProducts.map((product) => {
        const selectedConfigs = getSelectedLayerConfigs(product, props.selected);
        const showLayers = product.layers.length > 1;
        return (
          <div key={product.productKey} className="flex flex-col ml-6">
            <div>
              <label className="flex items-center gap-2 mr-2 py-1">
                <Checkbox checked disabled className="text-muted-foreground" />
                <span className="text-sm">{product.productName}</span>
              </label>
              {showLayers && (
                <div className="flex flex-col ml-6">
                  {product.layers
                    .filter((l) => selectedConfigs.includes(l.configName))
                    .map((layer) => (
                      <div key={layer.configName} className="flex items-center">
                        <label className="flex items-center gap-2 mr-2 py-1">
                          <Checkbox
                            checked
                            disabled
                            className="text-muted-foreground"
                          />
                          <span className="text-sm">{layer.layerName}</span>
                        </label>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};
